module.exports = __webpack_public_path__ + "static/img/4.5e3d47b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/services/4.png
// module id = jHJR
// module chunks = 0